import fetchClient from "api/client";
import CAMPAIGNS_ENDPOINT from "./campaignsEndpoint";

/**
 * @description DELETE api/campaigns/rules/:ruleId
 * */
export default function deletePhaseRule(ruleId) {
  if (!ruleId) {
    return Promise.reject(new Error("Rule ID is required."));
  }

  const url = `${CAMPAIGNS_ENDPOINT}/rules/${ruleId}`;

  return fetchClient.delete(url);
}
